import React from "react";
import InputsField from "../../../ControlUsuario/CamposDinamicos/InputsField";
import { Grid, Typography, Divider } from "@mui/material";
import Enumerable from "linq";

//
import { MOBILE } from "../../config";

/**
 *
 * @param {{ deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
const SectionFields = ({
  deviceIs = "DESKTOP",
  SectionId = "",
  SectionName = "",
  ListFields = [],
  SubModuloId = "",
  IdRelacionado = "",
  Elemento = "",
}) => {
  return (
    <React.Fragment>
      <Grid item xs={12} sm={12} md={12} style={{ padding: "8px 12px" }}>
        <Typography
          variant="h6"
          style={{
            textAlign: deviceIs === MOBILE ? "center" : "inherit",
            padding: "0px 10px 10px",
          }}
        >
          {SectionName}
        </Typography>
        <Grid
          key={SectionId}
          container
          spacing={2}
          style={{ backgroundColor: "transparent" }}
        >
          {Enumerable.from(ListFields)
            .orderBy((o) => o.displayOrder)
            .toArray()
            .map((elemento) => (
              <Grid
                item
                xs={12}
                sm={
                  ["LRG_TEXT", "RADIO", "FIX_TEXT"].includes(elemento.typeField)
                    ? 12
                    : 6
                }
                // sm={((elemento.typeField === 'LRG_TEXT' || elemento.typeField === 'RADIO') ? 12 : 6)}
                // md={((elemento.typeField === 'LRG_TEXT' || elemento.typeField === 'RADIO') ? 12 : 4)}
                md={
                  ["LRG_TEXT", "RADIO", "FIX_TEXT"].includes(elemento.typeField)
                    ? 12
                    : 4
                }
                key={elemento.fieldId}
              >
                {
                  <InputsField
                    key={elemento.fieldId}
                    CampoDinamico={elemento}
                    IdRelacionado={IdRelacionado}
                    SectionId={SectionId}
                    SubModuloId={SubModuloId}
                  />
                }
              </Grid>
            ))}
        </Grid>
      </Grid>
      <Divider style={{ margin: "12px -12px" }} />
    </React.Fragment>
  );
};

export default SectionFields;
